export default __webpack_public_path__ + "static/media/campaign_without_image.2fa726ed.png";